import { theme, ui } from "aaa";
import * as React from "react";
import { useState } from "react";

// This is a drop in replacement for material ui FlatButton
export const NativeFlatButton = (props: {
    style?: React.CSSProperties,
    buttonStyle?: React.CSSProperties,
    labelStyle?: React.CSSProperties,
    children?: any,
    primary?: boolean,
    secondary?: boolean,
    fullWidth?: boolean,
    label?: string,

    disabled?: boolean,
    type?: string,

    highlightColor?: string,

    onClick?: (event: any) => void,

    className?: string
}) => {
    const [hover, setHover] = useState(false);
    const [focus, setFocus] = useState(false);

    const height = (props.style && props.style.height) || 36;

    const highlightColor = props.highlightColor || "rgba(0,0,0,0.1)";

    let buttonWidth;
    if (props.style && props.style.width) {
        buttonWidth = props.style.width;
    } else if (props.fullWidth) {
        buttonWidth = "100%";
    }

    let background: any = "none";
    if (hover || focus) {
        background = highlightColor;
    } else if (props.style && props.style.backgroundColor) {
        background = props.style.backgroundColor;
    } else if (props.style && props.style.background) {
        background = props.style.background;
    }

    return (
        <button
            className={props.className}
            disabled={props.disabled}
            type={props.type}
            style={{
                display: "inline-block",
                cursor: props.disabled ? "auto" : "pointer",
                height: height,
                fontWeight: "bold",
                fontSize: "inherit",
                background: background,
                padding: 0,
                border: "none",
                transition: "all 0.3s",
                outline: "none",
                width: buttonWidth,
                ...props.style
            }}
            onMouseEnter={() => {
                if (!ui.isMobile) {
                    setHover(!props.disabled);
                }
            }}
            onMouseLeave={() => {
                if (!ui.isMobile) {
                    setHover(false);
                }
            }}
            onFocus={() => {
                setFocus(true);
            }}
            onBlur={() => {
                setFocus(false);
            }}
            onClick={(event) => {
                setFocus(false);
                if (props.onClick) {
                    props.onClick(event);
                }
            }}
        >
            {props.children}
            {props.label && <span
                style={{
                    paddingLeft: 16,
                    paddingRight: 16,
                    fontSize: 14,
                    color: props.disabled ? "rgba(0, 56, 95, 0.3)" : "white",
                    ...props.labelStyle
                }}
            >
                {props.label}
            </span>}
        </button>

    );
};




// WEBPACK FOOTER //
// ./src/components/common/NativeFlatButton.tsx